import * as React from 'react';
export const arvestSvg = React.forwardRef(function arvestSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#547391',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M23.79 23.22c.32.55.9 1.1 1.3 1.63h-4.14c.84-.32.54-1.1.27-1.7l-1.45-3.06H11.7l-1.27 3.24c-.27.72-.16 1.13.54 1.52v.16c-1.36 0-2.7 0-4.06.03v-.21a3.21 3.21 0 0 0 1.68-1.61c2.36-5.45 4.7-10.88 7.06-16.3 2.22 4.83 5.1 11.2 8.13 16.3zm-4.75-4.74-3.65-7.72-3.05 7.72h6.7z',
      }),
    ),
  );
});
arvestSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var arvest = {
  category: 'brand',
  colorable: false,
  name: 'arvest',
  svg: arvestSvg,
};
